<template>
  <div class="material">
    <material-delete-button
      class="d-flex justify-center items-center"
      :material="material"
      :getMaterial="getMaterial"
    ></material-delete-button>
    <img :src="materialUrl" :alt="material.materialName" />
    <div v-if="!isImageFile(material.materialUrl)" class="video-info">
      {{ convertSecTommss(material.materialDuration) }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import MaterialDeleteButton from '@/components/common/MaterialDeleteButton.vue';
import { isImageFile, getThumbnailUrl, convertSecTommss } from '@/composable/material_common';
import { AZURE_CDN } from '@/composable/constant';

// Propsの定義
const props = defineProps({
  material: {
    type: Object,
    default: () => ({}),
  },
  getMaterial: {
    type: Function,
    default: () => {},
  },
});

// computedプロパティの定義
const materialUrl = computed(() => {
  return `${AZURE_CDN.ENDPOINT}${getThumbnailUrl(encodeURI(props.material.materialUrl))}${
    AZURE_CDN.SAS
  }`;
});
</script>

<style scoped>
/* 素材 */
.material {
  position: relative;
  width: calc((100% - 0.2rem) / 3);
  aspect-ratio: 1;
  padding: 0px;
  border: 1px;
  border-color: white;
}
.material-delete-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  height: 2.2rem;
  width: 2.2rem;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  z-index: 1;
}
.material img,
.material video {
  object-fit: cover;
  height: 100%;
  width: 100%;
  vertical-align: top;
}
.video-info {
  position: absolute;
  bottom: 0.3rem;
  right: 0.5rem;
  padding-inline: 0.5rem;
  background: rgba(0, 0, 0, 0.34);
  font-family: 'Noto Sans JP';
  font-size: 1.4rem;
  color: white;
  z-index: 2;
}
@media screen and (min-width: 840px) {
  .material {
    width: calc((100% - 0.5rem) / 6);
  }
}
</style>
